module.exports = __webpack_public_path__ + "static/img/kefu_new.17943013.png";